import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { i18nService } from "../../i18n";
import Navbar from "./Navbar";
import Footer from "./Footer";
import Toolbar from "./Toolbar";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { globalServices } from "../../Services";
import { AuthContext } from "../../Contexts/AuthContext";

export default function Layout(props) {
  const history = useHistory();

  const { isActiveMenu, updatedResource, selectedLanguageId } =
    useContext(GlobalContext);

  const [isLoading, setIsLoading] = useState(true);

  const [translations, setTranslations] = React.useState();
  const [translationsCache, setTranslationsCache] = React.useState([]);
  const [i18nConfig, setI18nConfig] = React.useState(null);

  useEffect(() => {
    const data = translationsCache.find((tc) => tc.lang == selectedLanguageId);
    if (!data) {
      globalServices
        .getResourcesByLanguageId(selectedLanguageId)
        .then((data) => {
          setTranslationsCache([
            ...translationsCache,
            { lang: selectedLanguageId, translations: data.data },
          ]);
          setTranslations(data.data);
        })
        .catch(() => history.push("/Error"));
    } else {
      setTranslations(data.translations);
    }
  }, [selectedLanguageId]);

  useEffect(() => {
    // provjeravam da li su "cachirani" podaci za updateani language
    const data = translationsCache.find(
      (tc) => tc.lang == updatedResource.languageId
    );
    // console.log('data => ', updatedResource, data);
    // ako jesu moram updateati podatak bez obzira da li je trenutno odabrani jezik
    if (data) {
      var updatedTranslations = {
        ...data.translations,
        [updatedResource.key]: updatedResource.value,
      };
      // console.log('updatedTranslations', updatedTranslations);
      setTranslationsCache([
        ...translationsCache,
        { lang: selectedLanguageId, translations: updatedTranslations },
      ]);

      if (selectedLanguageId == updatedResource.languageId) {
        setTranslations(updatedTranslations);
      }
    }
  }, [updatedResource]);

  useEffect(() => {
    if (translations) {
      i18nService(translations).then((data) => {
        setI18nConfig(data);
        setIsLoading(false);
      });
    }
  }, [translations]);

  return (
    <>
      {!isLoading && (
        <I18nextProvider i18n={i18nConfig}>
          {/* {props.publicRoute ? (
            <div>{props.children}</div>
          ) : ( */}
          <>
            <Navbar />
            <div className="wrapper">
              <div
                className="container-fluid p-0"
                id={!isActiveMenu ? "content-wrap" : "content-wrap-full"}
              >
                <Toolbar
                  parentName={props.parentName}
                  parentRoute={props.parentRoute}
                  currentName={props.currentName}
                  showHome={false}
                  show={false}
                />
                <div className="container">{props.children}</div>
              </div>
            </div>
            <Footer />
          </>
          {/* )} */}
        </I18nextProvider>
      )}
    </>
  );
}
